var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.section)?_c('SPSection',{attrs:{"section":_vm.section}}):_vm._l((_vm.menu.sections),function(section){return _c('SPSection',{key:section.id,attrs:{"section":section}})}),(_vm.showFootnotes && _vm.menu.footnote)?_c('p',[_vm._v(_vm._s(_vm.menu.footnote))]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }